export default "__VITE_ASSET__DlxcI8eL__"